import { useEffect, useState } from 'react';
import { formatPrice } from '../../utils/timedPlayConfig';

export default function PerpetualTpSlModal({
  open,
  order,
  currentPrice,
  submitting,
  onClose,
  onConfirm,
}) {
  const [takeProfitPrice, setTakeProfitPrice] = useState('');
  const [stopLossPrice, setStopLossPrice] = useState('');
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    if (!open || !order) {
      return;
    }
    setTakeProfitPrice(order.takeProfitPrice != null ? String(order.takeProfitPrice) : '');
    setStopLossPrice(order.stopLossPrice != null ? String(order.stopLossPrice) : '');
    setLocalError('');
  }, [open, order]);

  if (!open || !order) {
    return null;
  }

  function handleConfirm() {
    if (!takeProfitPrice && !stopLossPrice) {
      setLocalError('請至少設置止盈或止損價格');
      return;
    }
    setLocalError('');
    onConfirm({
      takeProfitPrice: takeProfitPrice ? Number(takeProfitPrice) : null,
      stopLossPrice: stopLossPrice ? Number(stopLossPrice) : null,
    });
  }

  const isLong = order.orderType === 'LONG';

  return (
    <div className="trade-modal">
      <button type="button" className="trade-modal__backdrop" aria-label="關閉" onClick={onClose} />
      <div className="trade-modal__panel perpetual-order-modal">
        <header className="trade-modal__header">
          <h2>止盈止損</h2>
          <button type="button" className="trade-modal__close" aria-label="關閉" onClick={onClose}>
            ×
          </button>
        </header>

        <div className="trade-modal__summary">
          <div className="trade-modal__row">
            <span>方向</span>
            <strong className={isLong ? 'is-up' : 'is-down'}>{isLong ? '做多' : '做空'}</strong>
          </div>
          <div className="trade-modal__row">
            <span>開倉/委託價</span>
            <strong>{formatPrice(order.orderPrice, 4)}</strong>
          </div>
          <div className="trade-modal__row">
            <span>最新價格</span>
            <strong>{formatPrice(currentPrice, 4)}</strong>
          </div>
        </div>

        <label className="perpetual-order-modal__tpsl-field">
          <span>止盈價</span>
          <input
            type="number"
            min="0"
            step="0.0001"
            value={takeProfitPrice}
            placeholder="設置止盈價格"
            onChange={(e) => setTakeProfitPrice(e.target.value)}
          />
        </label>

        <label className="perpetual-order-modal__tpsl-field">
          <span>止損價</span>
          <input
            type="number"
            min="0"
            step="0.0001"
            value={stopLossPrice}
            placeholder="設置止損價格"
            onChange={(e) => setStopLossPrice(e.target.value)}
          />
        </label>

        {localError && <p className="trade-modal__error">{localError}</p>}

        <button
          type="button"
          className="trade-modal__confirm"
          disabled={submitting}
          onClick={handleConfirm}
        >
          {submitting ? '提交中…' : '確認'}
        </button>
      </div>
    </div>
  );
}
